<template>
    <b-modal
      no-close-on-backdrop
      centered
      ok-only
      size="lg"
      v-model="open"
      title="Adicionar colaborador"
      :busy="loading"
      footer-class="d-none"
    >
      <b-row v-if="loading">
        <b-col cols="12" class="text-center">
          <b-spinner label="Spinning"></b-spinner>
        </b-col>
      </b-row>

      <b-row v-else class="container">
        <b-col cols="12" class="mb-4">
            <label>Nome do colaborador</label>
            <input
                type="text"
                class="form-control"
                v-model="name"
                placeholder="Digite o nome do colaborador"
            />
        </b-col>

        <b-col cols="12" class="mb-4">
            <label>E-mail</label>
            <input
                type="email"
                class="form-control"
                v-model="email"
                placeholder="Digite o email do colaborador"
            />
        </b-col>

        <b-col cols="12" class="mb-4">
            <label>CPF</label>
            <input
                type="text"
                v-mask="['###.###.###-##']"
                class="form-control"
                v-model="cpf"
                placeholder="Digite o cpf"
            />
        </b-col>

        <b-col cols="12" class="mb-4">
            <label>WhatsApp</label>
            <input
                type="text"
                v-mask="['(##) #####-####', '(##) ####-####']"
                class="form-control"
                v-model="phone"
                placeholder="Digite o telefone"
            />
        </b-col>

        <b-col cols="12" class="mb-4 text-right">
            <b-button variant="success" class="mr-2" @click="save()">
                Salvar
            </b-button>
            <b-button variant="danger" @click="open = false">
                Fechar
            </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </template>
  
  <script>
  import makeToast from '@/mixins/makeToast';
  import UserTypes from '@/enums/UserTypes';
  import { mapState } from 'vuex';
  
  export default {
    name: 'ModalNewClerk',
    mixins: [makeToast],
    emits: ['clerkNew'],
   
    data() {
      return {
        loading: false,
        open: false,
        code: '',
        name: '',
        cpf: '',
        phone:'',
        email:'',
        data:[]
      };
    },
    computed: {
    ...mapState(['dadosUsuario']),
    },
    methods: {
        toggleOpen(data = []) {
            this.open = !this.open;
            this.code = '';
            this.name = '';
            this.cpf = '';
            this.phone ='';
            this.email ='';
            this.data = data;
        },

        uppercaseText(){
            this.code = this.code.toUpperCase();
        },

        unsMaskValor(value) {
            return parseInt(String(value).replace(/[\D]+/g, ''));
        },

        save() {
            if(this.name == ''){
                this.makeToast('Erro', 'Nome não pode estar vazio!', 'danger');
                return
            }
            if(this.email == ''){
                this.makeToast('Erro', 'Email não pode estar vazio!', 'danger');
                return
            }
            if(this.cpf == ''){
                this.makeToast('Erro', 'CPF não pode estar vazio!', 'danger');
                return
            }
            if(this.phone == ''){
                this.makeToast('Erro', 'WhatsApp não pode estar vazio!', 'danger');
                return
            }
  
            const data = {
                "construp_user_id": this.userTypeId(),
                "name": this.name,
                "email": this.email,
                "phone":this.unsMaskValor(this.phone),
                "code": this.code,
                "cpf": this.unsMaskValor(this.cpf),
                "status": 1,
            }
    
            this.$store.dispatch('startLoader');            
            this.$store.dispatch('shopkeeper/saveClerk', data)
            .then((response) => {
                if(response.data.data){
                    this.makeToast('Sucesso', 'Dados cadastrados com sucesso!', 'success');
                    this.$emit('clerkNew');
                    this.open = !this.open;
               }
            })
            .catch((error) => {
                 if (error.response && error.response.data && error.response.data.message) {
                    const errorMessage = error.response.data.message;
                    this.makeToast('Erro', `${errorMessage}`, 'danger');
                } else {
                    this.makeToast('Erro', 'Houve um erro ao salvar os dados, tente novamente', 'danger');
                }
            })
            .finally(() => {
                this.$store.dispatch('endLoader');
            })
        },
        userTypeId(){
            return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
        },
    },
  };
  </script>
  